export default __webpack_public_path__ + "static/media/photo-icon.ac307973.svg";